var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Typography } from "@uigovpe/components";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { goToOrLogin } from "../../hearings/utils/authNavigate";
import { sortConsultationItems } from "../utils/participation";
var previewContainerStyle = {
    background: "#CED2D7",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    maxHeight: 320,
    overflow: "hidden",
    position: "relative",
    width: "100%",
};
var previewOverlayStyle = {
    background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 70%, rgba(255,255,255,1) 100%)",
    inset: 0,
    pointerEvents: "none",
    position: "absolute",
    zIndex: 1,
};
var previewBodyStyle = {
    maxHeight: 320,
    opacity: 0.7,
    overflow: "hidden",
    padding: "24px 24px 112px",
    position: "relative",
};
var bottomActionsStyle = {
    bottom: 20,
    display: "flex",
    gap: 16,
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    zIndex: 2,
};
var gradientButtonStyle = {
    background: "linear-gradient(180deg, #0034B7 0%, #001445 100%)",
    border: "none",
    boxShadow: "0px 2px 2px 0px #FFFFFF59 inset, 0px 4px 6px 0px #00000040",
};
var questionBlockStyle = {
    display: "grid",
    gap: 12,
    paddingBottom: 24,
};
var inputLikeStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    minHeight: 96,
    padding: 12,
    resize: "none",
    width: "100%",
};
var optionsColumnStyle = {
    display: "grid",
    gap: 8,
};
var optionRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
};
var PreviewAction = function (_a) {
    var disabled = _a.disabled, label = _a.label, onClick = _a.onClick, _b = _a.useSecondary, useSecondary = _b === void 0 ? false : _b;
    return (_jsx(Button, { disabled: disabled, label: label, onClick: onClick, severity: useSecondary ? "secondary" : undefined, style: useSecondary ? undefined : gradientButtonStyle }));
};
export var ConsultationFormPreview = function (_a) {
    var _b;
    var consultationId = _a.consultationId, consultationItems = _a.consultationItems, consultationStatus = _a.consultationStatus, hasAnsweredForm = _a.hasAnsweredForm, _c = _a.hasToken, hasToken = _c === void 0 ? false : _c, _d = _a.isAuthenticated, isAuthenticated = _d === void 0 ? false : _d, isManagerMode = _a.isManagerMode, myContributionLoading = _a.myContributionLoading, openQuestion = _a.openQuestion, typeForm = _a.typeForm;
    var navigate = useNavigate();
    var _e = useAuth(), hasPortalConnect = _e.hasPortalConnect, authHasToken = _e.hasToken, login = _e.login;
    var items = sortConsultationItems(consultationItems);
    var hasRealItems = items.length > 0;
    var isActive = consultationStatus === "active" || consultationStatus === "closed";
    var actionLabel = myContributionLoading
        ? "Carregando..."
        : hasAnsweredForm
            ? "Ver minha contribuição"
            : "Contribuir";
    var ensureAuthThen = function (path) {
        goToOrLogin({
            hasPortalConnect: hasPortalConnect,
            hasToken: hasToken || authHasToken,
            isAuthenticated: isAuthenticated,
            login: login,
            navigate: navigate,
            path: path,
        });
    };
    return (_jsxs("div", __assign({ style: previewContainerStyle }, { children: [_jsx("div", { style: previewOverlayStyle }), _jsx("div", __assign({ style: previewBodyStyle }, { children: typeForm === "without_form" ? (_jsxs("div", __assign({ style: questionBlockStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "medium" }, { children: ["1.", " ", hasRealItems
                                    ? (_b = items[0]) === null || _b === void 0 ? void 0 : _b.description
                                    : openQuestion || "Contribuição aberta"] })), _jsx("textarea", { disabled: true, placeholder: "Os cidad\u00E3os responder\u00E3o aqui...", rows: 4, style: inputLikeStyle })] }))) : hasRealItems ? (items.map(function (item) { return (_jsxs("div", __assign({ style: questionBlockStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "medium" }, { children: [item.order, ". ", item.description, item.isRequired ? (_jsx("span", __assign({ style: { color: "#DC2626" } }, { children: " *" }))) : null] })), item.type === "text" ? (_jsx("textarea", { disabled: true, placeholder: "Resposta do cidad\u00E3o...", rows: 3, style: inputLikeStyle })) : (_jsx("div", __assign({ style: optionsColumnStyle }, { children: (item.consultationItemOptions || []).map(function (option) { return (_jsxs("label", __assign({ style: optionRowStyle }, { children: [_jsx("input", { disabled: true, type: item.type === "select_unique" ? "radio" : "checkbox" }), _jsx("span", { children: option.label })] }), option.id)); }) })))] }), item.id)); })) : (_jsx(Typography, { children: "O question\u00E1rio ser\u00E1 exibido aqui ap\u00F3s salvar a consulta." })) })), _jsxs("div", __assign({ style: bottomActionsStyle }, { children: [!isManagerMode ? (_jsx(_Fragment, { children: typeForm === "with_form" ? (_jsx(PreviewAction, { disabled: !isActive, label: actionLabel, onClick: function () { return ensureAuthThen("/form/".concat(consultationId)); } })) : (_jsx(PreviewAction, { disabled: !isActive, label: actionLabel, onClick: function () {
                                return ensureAuthThen("/contribution/".concat(consultationId));
                            } })) })) : null, typeForm === "with_form" ? (_jsx(PreviewAction, { disabled: !isActive, label: "Ver respostas", onClick: function () {
                            return ensureAuthThen("/form/".concat(consultationId, "?tab=responses"));
                        }, useSecondary: true })) : null] }))] })));
};
